export enum Role {
  All = 'All',
  Admin = 'admin',
  // Teacher = 'Teacher',
  // Student = 'Student',
}
